import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import PencilIcon from '@offerzen/zenicon/PencilIcon'
import Card from '../../../elements/Card'
import Subheading from '../../../typography/Subheading'
import Badge from '../../../elements/Badge'
import BadgeButton from '../../../elements/BadgeButton'

import styles from './styles'

const SectionCard = ({ icon, title, className, onClick, onEdit, children }) => (
  <Card className={styles.card} onClick={onClick}>
    <Subheading className={styles.header}>
      <Badge icon={icon} theme="light" />
      <strong>{title}</strong>

      {Boolean(onEdit) && <BadgeButton className={styles.editButton} onClick={onEdit} icon={PencilIcon} ariaLabel={`Edit ${title}`} />}
    </Subheading>

    <div className={cx(styles.body, className)}>{children}</div>
  </Card>
)

SectionCard.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  title: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  children: PropTypes.node,
}

export default SectionCard
